// extracted by mini-css-extract-plugin
export var closeButton = "_q7-2";
export var closeButtonIcon = "_q7-3";
export var lightboxContent = "_q7-1";
export var lightboxOverlay = "_q7-0";